module.exports = __webpack_public_path__ + "static/media/cwiczenie_7.bc820233.jpg";